import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET SITE INFO
// ===================================================================================
export const siteInfoIsLoading = () => {
	return {
		type: "SITE_INFO_IS_LOADING"
	};
};

export const siteInfoHasError = err => {
	return {
		type: "SITE_INFO_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const siteInfoSuccess = data => {
	return {
		type: "SITE_INFO_SUCCESS",
		data
	};
};

export function getSiteInfo() {
	return dispatch => {
		dispatch(siteInfoIsLoading());

		return axios
			.get(
				process.env.REACT_APP_API_URL +
					"load/?language=en&page=categories-content&custom=false",
				{
					headers: getHeader()
				}
			)
			.then(response => {
				return dispatch(siteInfoSuccess(response));
			})
			.catch(err => {
				// console.log('getSiteInfo error:', err)
				dispatch(siteInfoHasError(err));
			});
	};
}

// ===================================================================================
//  SET PAGE TITLE
// ===================================================================================
export function setpageTitle(title) {
	return {
		type: "SET_PAGE_TITLE",
		title
	};
}

// ===================================================================================
//  GET NOTICES
// ===================================================================================
export function noticesSuccess(notice) {
	return {
		type: "GET_NOTICES_SUCCESS",
		notice
	};
}

export function getNotices() {
	return dispatch => {
		// dispatch(siteInfoIsLoading())

		return axios
			.get(process.env.REACT_APP_API_URL + "notices", {
				headers: getHeader()
			})
			.then(response => {
				// console.log('getSiteInfo success')
				dispatch(noticesSuccess(response.data.notice));
			})
			.catch(err => {
				console.log("getNotices error:", err);
				// dispatch(siteInfoHasError(err))
			});
	};
}

// ===================================================================================
//  GET PROMOS
// ===================================================================================
export function promosSuccess(promos) {
	return {
		type: "GET_PROMOS_SUCCESS",
		promos
	};
}

export function getPromos() {
	return dispatch => {
		return axios
			.get(process.env.REACT_APP_API_URL + "promos", {
				headers: getHeader()
			})
			.then(response => {
				dispatch(promosSuccess(response.data.promos));
			})
			.catch(err => {
				console.log("getPromos error:", err);
				// dispatch(siteInfoHasError(err))
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/siteInfo.js